const variables = require('sass-extract-loader?{"plugins":[{ "plugin": "sass-extract-js", "options": {"camelCase": false}}]}!../../assets/stylesheets/_variables.scss') // eslint-disable-line

export default variables
